var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeavecalFinlert1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 633.11 150.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3043e9;}.cls-2{fill:#0d1d6d;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183,79V93.21H121V8.94h17.62V79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.72,67.93h-45.2q2.68,13.53,16,13.53a18.08,18.08,0,0,0,9.06-2,10.87,10.87,0,0,0,5-5.88l14.3,5.24a22.62,22.62,0,0,1-10.27,11.68q-7.22,4-18.07,4-15.84,0-24.51-8.74t-8.69-24.45q0-15.7,8.43-24.45t23.75-8.75q14.81,0,22.79,8.56t8,24.38A45.53,45.53,0,0,1,250.72,67.93ZM210.18,44.69q-3.77,3.7-4.79,11h29.75c-.68-4.77-2.3-8.4-4.85-10.92a13.6,13.6,0,0,0-10-3.76Q213.94,41,210.18,44.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.41,82.1l-1.28,10.59a18.37,18.37,0,0,1-8.3,1.79q-12.25,0-14.68-9.57a17.49,17.49,0,0,1-8.68,7.15,36.52,36.52,0,0,1-13.92,2.42q-9.33,0-14.56-4.21t-5.23-12.13q0-15.57,24.9-20.17L299,55V52a11.21,11.21,0,0,0-2.88-8.11q-2.87-3-8-3a16.54,16.54,0,0,0-9.57,2.55q-3.71,2.55-5.11,8.3l-13.92-5.87a21.21,21.21,0,0,1,9.2-13q7.14-4.71,18.64-4.72,13.65,0,21.32,5.94t7.66,17.55V77.76a5.06,5.06,0,0,0,1.15,3.7,4.86,4.86,0,0,0,3.57,1.15A15.24,15.24,0,0,0,325.41,82.1Zm-31.09-2.24Q299,77.12,299,72.4V65.76l-13.67,3.06a16,16,0,0,0-6.44,2.75,5.81,5.81,0,0,0-2.11,4.78A5.7,5.7,0,0,0,278.68,81a8.09,8.09,0,0,0,5.36,1.6A19.91,19.91,0,0,0,294.32,79.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.27,29.37,366,93.21H345.83L321.58,29.37h18.76L356.05,81l16.09-51.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451.81,67.93h-45.2q2.67,13.53,16,13.53a18.08,18.08,0,0,0,9.06-2,10.87,10.87,0,0,0,5-5.88l14.3,5.24a22.62,22.62,0,0,1-10.27,11.68q-7.22,4-18.07,4-15.84,0-24.51-8.74t-8.69-24.45q0-15.7,8.43-24.45t23.75-8.75q14.81,0,22.79,8.56t8,24.38A45.53,45.53,0,0,1,451.81,67.93ZM411.27,44.69q-3.76,3.7-4.79,11h29.75c-.68-4.77-2.3-8.4-4.85-10.92a13.62,13.62,0,0,0-10-3.76Q415,41,411.27,44.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.11,88.42a36.78,36.78,0,0,1-20.94,6.06q-11.87,0-20.68-5.3a35.17,35.17,0,0,1-13.6-15.06q-4.78-9.77-4.79-23.05t4.79-23A35.13,35.13,0,0,1,478.49,13a38.87,38.87,0,0,1,20.43-5.3q12.13,0,20.36,5a30.4,30.4,0,0,1,12.33,14.68l-10.09,4.73a22.85,22.85,0,0,0-8.17-11.11q-5.37-3.71-13.66-3.7a28.32,28.32,0,0,0-15.2,4,26.44,26.44,0,0,0-10.08,11.68,42.43,42.43,0,0,0-3.58,18.13q0,15.84,7.6,24.84t20.74,9A25.34,25.34,0,0,0,514,80.57a23.63,23.63,0,0,0,8.94-12.77l10.22,3.83A33.58,33.58,0,0,1,520.11,88.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602,85.16l-.64,8a22.58,22.58,0,0,1-7.65,1.27q-5,0-7.86-2.17c-1.91-1.44-3.13-3.87-3.64-7.27A19.16,19.16,0,0,1,573.54,92a29.36,29.36,0,0,1-11.93,2.49q-9.45,0-15.58-4.4T539.9,77.37q0-7.28,6.38-12.57t18.52-7.35l17-2.8V51.07a13.55,13.55,0,0,0-4-10.21q-4-3.84-11-3.83a18.65,18.65,0,0,0-18.26,12.13l-7.53-5.49a21.5,21.5,0,0,1,9.51-11.37,30.82,30.82,0,0,1,16.28-4.21q11.37,0,18.26,5.49T592,49.8V81.2a4.69,4.69,0,0,0,1.15,3.45,5.07,5.07,0,0,0,3.71,1.15A20.72,20.72,0,0,0,602,85.16Zm-26-3.44q5.81-3.84,5.81-10V63l-14.3,2.68q-8.55,1.53-12.77,4.4t-4.21,7.34a6.93,6.93,0,0,0,3.06,6.07c2.05,1.4,4.9,2.11,8.56,2.11A24.61,24.61,0,0,0,576,81.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M616.89,76.1c0,3.23.49,5.47,1.47,6.7s2.79,1.85,5.43,1.85a25.43,25.43,0,0,0,4.66-.38,28.81,28.81,0,0,0,4.66-1.41l-1.66,9.83A24,24,0,0,1,622,94.48q-7.79,0-11.56-4.21t-3.76-12.9V0h10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.9,127.33a11.59,11.59,0,0,1,0,13.53,7.52,7.52,0,0,1-5.92,2.46,7.23,7.23,0,0,1-3.67-.93,6,6,0,0,1-2.4-2.51l-.18,3.09h-2.48V117.05h2.84V128a6.28,6.28,0,0,1,2.4-2.28,7.21,7.21,0,0,1,3.49-.85A7.53,7.53,0,0,1,135.9,127.33ZM133.75,139a8.87,8.87,0,0,0,0-9.84,5,5,0,0,0-4.09-1.83,5.08,5.08,0,0,0-4.06,1.78,7.08,7.08,0,0,0-1.51,4.76v.43a7.05,7.05,0,0,0,1.51,4.75,5,5,0,0,0,4.06,1.78A5,5,0,0,0,133.75,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.42,146a9,9,0,0,1-2.31,3.61,5.05,5.05,0,0,1-3.3,1,6.17,6.17,0,0,1-2.26-.35,4.51,4.51,0,0,1-1.65-1.14l1-2.41a3.38,3.38,0,0,0,2.88,1.42,2.91,2.91,0,0,0,1.83-.62,5.16,5.16,0,0,0,1.4-2.26l.93-2.31-7.42-17.72h3.23l4.44,11.58,1.09,3.16,1.28-3.51,4.16-11.23h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.11,119.74a9,9,0,0,1,2.5,6.82v16.57h-6.92V128.58q0-5.76-4.5-5.76a5.53,5.53,0,0,0-4.11,1.72c-1.13,1.14-1.7,2.9-1.7,5.25v13.34h-6.92V117.75h6.22l.2,4.62a8.71,8.71,0,0,1,3.48-3.74,10.3,10.3,0,0,1,5.16-1.26A9.2,9.2,0,0,1,218.11,119.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.38,133.13H245.5c.71,3.57,2.81,5.35,6.32,5.35a7.1,7.1,0,0,0,3.58-.81,4.28,4.28,0,0,0,2-2.32l5.66,2.07A8.93,8.93,0,0,1,259,142a14.51,14.51,0,0,1-7.14,1.59q-6.27,0-9.7-3.46t-3.44-9.67q0-6.21,3.34-9.67t9.39-3.46q5.86,0,9,3.38t3.16,9.65A17.36,17.36,0,0,1,263.38,133.13Zm-16-9.2a7.33,7.33,0,0,0-1.9,4.35h11.77A7.3,7.3,0,0,0,255.3,124a5.39,5.39,0,0,0-3.94-1.49A5.49,5.49,0,0,0,247.35,123.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 185.42,
    y: 117.75,
    width: 6.92,
    height: 25.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 188.88,
    cy: 111.36,
    r: 3.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.37,115.35c0-2.6,1.44-3.89,4.34-3.89a5.21,5.21,0,0,1,2.88.75v0l.62-4.77a6.94,6.94,0,0,0-1.87-.74,12.09,12.09,0,0,0-3-.36,10.4,10.4,0,0,0-7,2.2,7.88,7.88,0,0,0-2.58,6.34v2.91h-3.84l-.66,5.23h4.5v20.15h6.92V123h6.93v-5.23h-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.07,137a5.88,5.88,0,0,1-3.88,1.4c-2.32,0-3.49-1.16-3.49-3.49V122.71h6.8v-5.08h-6.8v-7.49l-6.92.85v6.64h-3.64l-.65,5.08h4.29V136q0,7.63,8.44,7.63a13.29,13.29,0,0,0,3.86-.55,9.76,9.76,0,0,0,2.62-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.07,117.59a8.18,8.18,0,0,0-1.73-.17,7.77,7.77,0,0,0-7.63,5l-.2-4.6h-6.26v25.4h6.92V129.86a6.8,6.8,0,0,1,1.79-5,9.85,9.85,0,0,1,6.4-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.67,135.15a4.41,4.41,0,0,0,.53,2.52,2.26,2.26,0,0,0,1.94.71,7.18,7.18,0,0,0,1.49-.13,9.65,9.65,0,0,0,1.5-.43l-.61,4.8a6.67,6.67,0,0,1-2.12.79,12.86,12.86,0,0,1-2.58.27c-2.46,0-4.25-.59-5.38-1.79s-1.69-3.11-1.69-5.73V107.68l6.92-.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.01,
    cy: 52.85,
    r: 51.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.34,47.24V72.75a5.12,5.12,0,0,0,5.12,5.13h47.2a5.12,5.12,0,0,0,5.12-5.13V47.24Zm5.12-19.15a5.12,5.12,0,0,0-5.12,5.13V44.69H80.78V33.22a5.12,5.12,0,0,0-5.12-5.13H69.31v5.45a3.78,3.78,0,0,1,1.28,2.85,3.83,3.83,0,1,1-7.66,0,3.78,3.78,0,0,1,1.28-2.85V28.09H39.93v5.43a3.79,3.79,0,0,1,1.3,2.87,3.83,3.83,0,1,1-6.4-2.83V28.09Zm38.3-3.83a1.28,1.28,0,0,0-1.28,1.28V36.39a1.28,1.28,0,0,0,2.56,0V25.54A1.28,1.28,0,0,0,66.76,24.26Zm-29.36,0a1.28,1.28,0,0,0-1.28,1.28V36.39a1.28,1.28,0,0,0,2.56,0V25.54A1.28,1.28,0,0,0,37.4,24.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.77,
    cy: 56.5,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 57.59,
    cy: 56.5,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.5,
    cy: 56.5,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.77,
    cy: 67.82,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.68,
    cy: 67.82,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 57.59,
    cy: 67.82,
    r: 3.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavecalFinlert1);
export default __webpack_public_path__ + "static/media/leavecal_finlert-1.c7ed306ef7f0ada3e4acb85e0fcbefec.svg";
export { ForwardRef as ReactComponent };